import actions from './actions';
import types from './constants';
import services from '../../services/benchmark';
import { generateBenchmarkReport } from '../../util/generators/generateBenchmarkReport';
import get from 'lodash.get';
import { ASSESSMENT_TYPE_FILTERS } from '../../../../constants/constants';

const benchmarkSort = (sort) => (dispatch) => {
  dispatch(actions[types.BENCHMARK_SORT](sort));
};

const fetchReport = (classroom, metric, scale, benchmark, customBenchmarks, equating, selectedLocale, selectedStatePercentileCuts) => (dispatch, getState) => {

  let state = getState()
  let students = get(state, 'reports.roster.data.student')
  const isBenchmarkOnly = get(state, 'reports.teacher.selectedAssessmentTypeFilter') === ASSESSMENT_TYPE_FILTERS.BENCHMARK_ONLY;
  const window = get(state, "reports.teacher.selectedScreeningWindow")
  const cachedBenchmarkData = get(state, `reports.benchmark.report.cachedData.${classroom}`)
  dispatch(actions[types.BENCHMARK_PENDING]())
  services.fetchActivities(classroom, equating, selectedLocale, window, cachedBenchmarkData, dispatch)
  .then(async (activities) => {
    const report = await generateBenchmarkReport(activities, metric, scale, benchmark, customBenchmarks, selectedLocale, students, isBenchmarkOnly,window, selectedStatePercentileCuts);
    dispatch(actions[types.BENCHMARK_COMPLETE](report, activities));
  })
  .catch((e) => {
    console.log("ERROR:",e)
    dispatch(actions[types.BENCHMARK_ERROR](e.message))
  });
};

const scaleReport = (activities, metric, scale, benchmark, customBenchmarks, selectedLocale, selectedStatePercentileCuts) => async (dispatch, getState) => {
  let state = getState()
  let students = get(state, 'reports.roster.data.student')
  const window = get(state, "reports.teacher.selectedScreeningWindow")
  const isBenchmarkOnly = get(state, 'reports.teacher.selectedAssessmentTypeFilter') === ASSESSMENT_TYPE_FILTERS.BENCHMARK_ONLY;
  if(activities && activities.length > 0) {
    const report = await generateBenchmarkReport(activities, metric, scale, benchmark, customBenchmarks, selectedLocale, students, isBenchmarkOnly,window, selectedStatePercentileCuts);
    dispatch(actions[types.BENCHMARK_COMPLETE](report, activities));
  }
};

export default {
  benchmarkSort,
  fetchReport,
  scaleReport,
}